import GenericModel from '../generic-model';
import Employee from '../product/employee';
import { TourItem } from './tour-item';

export class Tour extends GenericModel {
  date?: Date;

  reviewDate?: Date;

  checked?: boolean;

  routeChecked?: boolean;

  placerAbsent?: boolean;

  placer?: Employee;

  atelierEmployee?: Employee;

  reviewEmployee?: Employee;

  atelierDate?: Date;

  atelierFinished?: boolean;

  atelierReviewed?: boolean;

  atelierInProgress?: boolean;

  atelierSequence?: number;

  tourItems?: TourItem[];

  // display variables
  selectedForPreview?: boolean;
}
